import React from 'react'
import { CCol, CContainer, CRow } from '@coreui/react-pro'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={6}>
            <div className="clearfix">
              <h1 className="float-start display-3 me-4">404</h1>
              <h4 className="pt-3">Oops! Você se perdeu.</h4>
              <p className="text-medium-emphasis float-start">
                O conteúdo que está buscando não foi encontrado...
                <br />
                <br />
                <Link to={'/'}>Voltar ao Início</Link>
              </p>
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default NotFound
